import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b008fdae"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hello-statement" }, "Hey there, I'm ", -1))
const _hoisted_2 = { class: "links-container" }
const _hoisted_3 = { class: "links-container__list" }
const _hoisted_4 = { class: "home-text emphasis-red" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "link-underline" }, "Zach Smith.", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "home-text__text" }, "Zach Smith.", -1))
const _hoisted_7 = { class: "extra-links" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("  |  ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("full stack dev")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("  | ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("sound design")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["heading left-align", { 'hide-hello': _ctx.condenseHeader }])
  }, [
    _hoisted_1,
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", _hoisted_4, [
          _createVNode(_component_router_link, {
            class: "home-text__link",
            to: "/"
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _hoisted_6
        ]),
        _createElementVNode("template", _hoisted_7, [
          _createElementVNode("li", null, [
            _hoisted_8,
            _createVNode(_component_router_link, {
              to: "/webdev",
              class: "link-underline all-caps"
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }),
            _hoisted_10
          ]),
          _createElementVNode("li", null, [
            _hoisted_11,
            _createVNode(_component_router_link, {
              to: "/sounddesign",
              class: "link-underline all-caps"
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ], 2))
}